import React from 'react';
import styled from 'styled-components';

import Logo from '../../Logo/Logo';
import NavigationItems from '../NavigationItems/NavigationItems';
import Backdrop from '../../Backdrop/Backdrop';
import Aux from '../../Aux/Aux';
import { mediaMin } from '../../Media Template/Media Template';

const SideDrawer = styled.div.attrs({
  scale: props => props.scale || 'transform: translateX(-100%);'
})`
  position: fixed;
  top: 0;
  left: 0;
  width: 320px;
  min-width: 192px;
  max-width: 60%;
  height: 100%;
  z-index: 200;
  background: white;
  padding: 32px 16px;
  transform: ${props => props.scale};
  transition: transform 0.3s ease-out;
  ${mediaMin.desktop`display:none;`};
`;

const sideDrawer = props => {
  // console.log('props: ', props);
  return (
    <Aux>
      <Backdrop clasName="Backdrop" show={props.open} clicked={props.closed} />
      <SideDrawer
        className="SideDrawer"
        onClick={props.closed}
        scale={props.open ? 'translateX(0);' : 'translateX(-100%);'}
      >
        <Logo>Beebom</Logo>
        <nav
          style={
            props.open === false ? { display: 'none' } : { display: 'block' }
          }
        >
          <NavigationItems />
        </nav>
      </SideDrawer>
    </Aux>
  );
};

export default sideDrawer;
